import { createUuid } from "../../../lib/trace/context";
import type { ResolvedItineraryResourceEntry } from "../../../shared/itinerary-resource-entry";
import type { QuoteBudgetLine } from "../types";
import { calculateLineAmount } from "./quoteBudgetCalculationService";

const PERSON_UNITS = new Set(["人晚", "人餐", "人次", "张", "人天"]);

/** 把共享解析结果适配为核价草稿行，功能域主键、行号与持久化字段只在此边界生成。 */
export function adaptResolvedEntriesToQuoteBudgetLines(
  entries: ResolvedItineraryResourceEntry[],
  startingLineNo: number,
): QuoteBudgetLine[] {
  return entries.map((entry, index) => {
    const line: QuoteBudgetLine = {
      budgetLineId: createUuid(),
      lineNo: startingLineNo + index,
      resourceType: entry.resourceType,
      resourceEntryType: entry.resourceEntryType,
      spuTableName: entry.spuTableName ?? null,
      spuId: entry.spuId ?? null,
      spuNameSnapshot: entry.spuName ?? "",
      skuTableName: entry.skuTableName ?? null,
      skuId: entry.skuId ?? null,
      skuNameSnapshot: entry.skuName ?? "",
      itemNameSnapshot: entry.itemName,
      itemSpecSnapshot: entry.spec,
      unit: entry.unit,
      travelerRole: entry.travelerRole,
      mealType: entry.mealType,
      peopleMode: entry.isLinkedToPeopleCount === false ? "manual" : "linked",
      manualPeopleCount: entry.manualPeopleCount === null || entry.manualPeopleCount === undefined
        ? null
        : String(entry.manualPeopleCount),
      isLinkedToPeopleCount: entry.isLinkedToPeopleCount ?? PERSON_UNITS.has(entry.unit),
      isCapitaShared: true,
      isAgentCollection: entry.resourceType === "大交通",
      nightCount: entry.nightCount,
      dayCount: entry.dayCount,
      quantity: String(entry.quantity),
      budgetUnitPrice: entry.unitPriceText ?? String(entry.unitPrice),
      budgetAmount: entry.amount,
      priceSourceType: "manual",
      priceSourceRef: entry.priceSourceRef ?? null,
      priceBasisDesc: `自然语言录入：${entry.sourceText}`,
    };
    line.budgetAmount = calculateLineAmount(line);
    return line;
  });
}
